import { render, staticRenderFns } from "./LogMessage.vue?vue&type=template&id=1b35afc1&scoped=true&"
import script from "./LogMessage.vue?vue&type=script&lang=js&"
export * from "./LogMessage.vue?vue&type=script&lang=js&"
import style0 from "./LogMessage.vue?vue&type=style&index=0&id=1b35afc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b35afc1",
  null
  
)

export default component.exports